import { hasAnySim, isAllNao, isPerguntaOutroFilled } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta20ExemplosEnum,
  ConsultaSeguimentoPergunta20Model,
} from './model-consultaSeguimentoPergunta20'

const pergunta20ExemplosEnumValues = Object.values(ConsultaSeguimentoPergunta20ExemplosEnum)

/* 
  Para as funções da Pergunta 20, o campo Outros preenchido é considerado como Exemplo positivo (valor Sim)
  por isso só é verificado se está preenchido
*/

export const isPergunta20ExemplosAllNao = (value: ConsultaSeguimentoPergunta20Model): boolean => {
  if (isPerguntaOutroFilled(value?.PERGUNTA_20_OUTRO)) {
    return false
  }

  return isAllNao(value?.PERGUNTA_20_EXEMPLOS, pergunta20ExemplosEnumValues)
}

export const hasPergunta20ExemplosAnySim = (value: ConsultaSeguimentoPergunta20Model): boolean => {
  return hasAnySim(value?.PERGUNTA_20_EXEMPLOS) || isPerguntaOutroFilled(value?.PERGUNTA_20_OUTRO)
}
